
export const AuthResponsable = ({auth, handleChange, error, titol, textAddicional}) =>
{
      return (
        <>
      <div className="row">
        <div className="col col-12 ">
          <h4>
            {titol || "Declaració responsable de veracitat de les dades aportades"}
          </h4>
          <p>
            <input type="checkbox" id="authResponsable" name="authResponsable" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
            <label htmlFor="authResponsable">Declaro que totes les dades aportades en aquest procediment són certes i la possibilitat d'acreditar documentalment totes les dades esmentades anteriorment, en cas que se m'exigeixin.{textAddicional && (<> {textAddicional}</>)}</label>
            <span id="auhtResponsable" className="a-Form-error">{error}</span>
          </p>

        </div>
      </div>

      <br/>
      </>)
}